import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageOrderderService } from 'src/app/shared/services/manage-orderder.service';

@Component({
  selector: 'app-view-menu-details',
  templateUrl: './view-menu-details.component.html',
  styleUrls: ['./view-menu-details.component.scss','../../../modules/dashboard/organization-dash/organization-dash.component.scss']
})
export class ViewMenuDetailsComponent implements OnInit {

  @Input()
  productsList;
  
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubServ: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,
  ) { }

  ngOnInit(): void {
  }

  @Output() clickmenuback = new EventEmitter();

  onclickmenuback(){
    this.clickmenuback.emit();
  }
}
